import React from 'react';
import * as S from './CombineModes.styles';

/**
 * "Combine modes" pills for how-to-play pages.
 * Renders each combination as two chips joined by an orange "+" badge.
 *
 * Props:
 *  - examples: array of { left, right } strings
 */
const CombineModes = ({ examples = [] }) => {
  if (!Array.isArray(examples) || examples.length === 0) return null;

  return (
    <S.Grid>
      {examples.map((combo, idx) => (
        <S.Combo key={idx}>
          <S.ComboChip>{combo.left}</S.ComboChip>
          <S.PlusBadge aria-hidden="true">+</S.PlusBadge>
          <S.ComboChip>{combo.right}</S.ComboChip>
        </S.Combo>
      ))}
    </S.Grid>
  );
};

export default CombineModes;
